import { publicUrlFor, route } from "../../../../globals/constants";
import FastImage from "../../../../globals/elements/fastimg";
import { NavLink } from "react-router-dom";

function Title1({ options, data }) {
    return (
        <div className="section-full  p-t80 p-b50">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12">
                        <div className="mt-box m-b30">
                            <div className="mt-thum-bx mt-img-effect">
                                <FastImage src={options?.image} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="mt-box sx-what-wedo">
                            <span className="site-text-primary display-block title-second text-uppercase font-20 font-weight-600 display-block m-b15">{options?.title}</span>
                            <h2 className="m-t0">{options.description}</h2>
                            <p>{options?.description2}</p>
                            <NavLink to={route.pages.ABOUT} className="site-button">Read More</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Title1;

